import { createFabricCanvas } from "@/lib/canvas-utils";
import { Canvas } from "fabric/fabric-impl";
import { useCallback, useEffect, useRef } from "react";

export function useCanvas(
  callback?: (canvas: Canvas & { name?: string }) => any
) {
  const elementRef = useRef<HTMLCanvasElement | null>(null);
  const fc = useRef<Canvas | null>(null);
  const callbackRef = useRef(callback);

  const setRef = useCallback((ref: HTMLCanvasElement | null) => {
    elementRef.current = ref;
    // dispose canvas
    fc.current?.dispose();
    // set/clear ref
    if (!ref) {
      fc.current = null;
      return;
    }
    const canvas = createFabricCanvas(ref, {
      backgroundColor: "white",
      fireRightClick: true,
      stopContextMenu: true,
    }) as Canvas;

    fc.current = canvas;
    // invoke callback
    if (callbackRef.current) callbackRef.current(canvas);
  }, []);

  useEffect(() => {
    // disposer
    return () => {
      // we avoid unwanted disposing by doing so only if element ref is unavailable
      if (!elementRef.current) {
        fc.current?.dispose();
        fc.current = null;
      }
    };
  }, []);

  return [fc, setRef] as [typeof fc, typeof setRef];
}
